import * as React from 'react';
export const IcShoppingBasket = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.57 9.76A2 2 0 0020 9h-1.4l-2.74-4.51a1 1 0 00-1.72 1L16.23 9H7.77l2.09-3.49a1 1 0 00-1.72-1L5.43 9H4a2 2 0 00-1.98 2.44l1.42 6.22a3 3 0 003 2.34h11.1a3 3 0 003-2.34L22 11.44a2.001 2.001 0 00-.43-1.68z'
      fill='currentColor'
    />
  </svg>
);
